module.exports = __webpack_public_path__ + "static/media/2021qd.298b5d4e.jpg";